// File: src/import/AxiosConfig.js (or wherever you keep axiosInstance)
import axios from "axios";

/* --------- Lightweight geo cache (no extra files needed) --------- */
let GEO_CACHE = null;
const GEO_LS_KEY = "geo_headers_cache";

function loadGeoFromLS() {
  if (GEO_CACHE) return GEO_CACHE;
  try {
    GEO_CACHE = JSON.parse(localStorage.getItem(GEO_LS_KEY)) || {};
  } catch {
    GEO_CACHE = {};
  }
  return GEO_CACHE;
}

function saveGeoToLS(obj) {
  GEO_CACHE = { ...(GEO_CACHE || {}), ...(obj || {}) };
  try {
    localStorage.setItem(GEO_LS_KEY, JSON.stringify(GEO_CACHE));
  } catch {}
}

// Try to capture coords once (non-blocking)
(function bootGeotag() {
  if (!("geolocation" in navigator)) return;
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude } = pos.coords || {};
      if (latitude != null && longitude != null) {
        saveGeoToLS({ lat: latitude, lng: longitude });
      }
    },
    () => {},
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 600000 },
  );
})();
/* --------------------------------------------------------------- */

const axiosInstance = axios.create({
  // Default; interceptor will switch based on subdomain
  baseURL: "https://rupioodms-backend.rupioo.in",
  // baseURL: "http://192.168.29.232:3909",
});

// Subdomain-aware baseURL + identity + geotag headers
axiosInstance.interceptors.request.use((config) => {
  // --- Base URL by subdomain ---
  const host = window.location.hostname;
  const subdomain = host.split(".")[0];

  if (subdomain === "customer") {
    config.baseURL = "https://customer-node.rupioo.com";
  } else if (subdomain === "admin") {
    config.baseURL = "https://node.rupioo.com";
  } else {
    // Local / fallback
    config.baseURL = "https://rupioodms-backend.rupioo.in";
    // config.baseURL = "http://192.168.29.232:3909";
  }

  // --- Identity headers (optional if your backend already sets req.user) ---
  try {
    const user = JSON.parse(localStorage.getItem("userData")) || {};
    if (user?._id) config.headers["x-user-id"] = user._id;
    const displayName = user?.fullName || user?.CompanyName || user?.name;
    if (displayName) config.headers["x-user-name"] = displayName;
    if (user?.email) config.headers["x-user-email"] = user.email;
  } catch {}

  // --- Geotag headers (optional nice-to-have) ---
  const geo = loadGeoFromLS();
  if (geo?.lat != null) config.headers["x-geo-lat"] = geo.lat;
  if (geo?.lng != null) config.headers["x-geo-lng"] = geo.lng;
  if (geo?.city) config.headers["x-geo-city"] = geo.city; // set these if you enrich later
  if (geo?.state) config.headers["x-geo-state"] = geo.state;

  return config;
});

export default axiosInstance;
